export default "//cdn.scentbird.com/assets/frontbird-site/images/diffuser_f806fc.png";